import { z } from 'zod';

/**
 * Schema for warehouse form data
 */
export const warehouseSchema = z.object({
  unit_id: z.string().nullable().optional(),
  ma_unit: z.string().min(1, { message: 'Mã đơn vị không được để trống' }),
  unit_name: z.string().optional(),
  ma_kho: z.string().min(1, { message: 'Mã kho không được để trống' }),
  ten_kho: z.string().min(1, { message: 'Tên kho không được để trống' }),
  ten_kho2: z.string().nullable().optional(),
  vi_tri_yn: z.boolean().default(false),
  dai_ly_yn: z.boolean().default(false),
  ma_nh: z.string().nullable().optional(),
  dia_chi: z.string().optional(),
  dien_thoai: z.string().optional(),
  ghi_chu: z.string().nullable().optional(),
  status: z.string().default('1'),
  entity_model: z.string().default('warehouse')
});

export type WarehouseFormValues = z.infer<typeof warehouseSchema>;

/**
 * Initial values for warehouse form
 */
export const initialFormValues: WarehouseFormValues = {
  unit_id: null,
  ma_unit: '',
  unit_name: '',
  ma_kho: '',
  ten_kho: '',
  ten_kho2: null,
  vi_tri_yn: false,
  dai_ly_yn: false,
  ma_nh: null,
  dia_chi: '',
  dien_thoai: '',
  ghi_chu: null,
  status: '1',
  entity_model: 'warehouse'
};

/**
 * Schema for warehouse search
 */
export const searchSchema = z.object({
  ma_kho: z.string().optional(),
  ten_kho: z.string().optional(),
  ma_unit: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
